import { combineReducers } from 'redux';
import { stateParamName as officesStateParamName } from './models/offices/model';
import officesReducer from './models/offices/reducer';

export default combineReducers({
  [officesStateParamName]: officesReducer
});
